import script from "./TechnicianManagerPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./TechnicianManagerPanel.vue?vue&type=script&setup=true&lang=js"

import "./TechnicianManagerPanel.vue?vue&type=style&index=0&id=79d8f1db&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79d8f1db"]])

export default __exports__